import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The Lucide "sparkles" SVG icon — shared between the FAB badge and the insight banner.
 * Callers differ on both size and stroke width, so both are signal inputs with safe defaults.
 */
@Component({
	selector: 'app-flo-spark-icon',
	standalone: true,
	imports: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 24 24" fill="none"
		     stroke="currentColor" [attr.stroke-width]="strokeWidth()"
		     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
			<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
			<path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>
		</svg>
	`
})
export class FloSparkIconComponent {
	readonly size = input(16);
	readonly strokeWidth = input(2);
}
